import { Card, Col, Row, Typography, Button, Tooltip, Modal, message,Pagination } from "antd";
import { useNavigate, useLocation } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { ArrowLeftOutlined, DeleteOutlined, EditOutlined, EyeOutlined } from "@ant-design/icons";

import { getPlainTextSummary } from "../../utils/HtmlHelper";
import PageLoader from "../../components/custom/PageLoader";
import geofenceNotificationApi from '../../services/geofenceNotificationApi';
import { NotificationStatusMapper } from "../../utils/notificationStatusMapper";
import { addOneMinute } from "../../utils/TimeHelper";

const { Title } = Typography;

const NotificationListGeofencePage: React.FC = () => {
  
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const statusId :number  = Number(searchParams.get("statusId") ?? 999);
  const navigationTitle = searchParams.get('navigationTitle');

  const statusName = NotificationStatusMapper.getNotificationStatusName(statusId);

  const deleteMessage = `Are you sure you want to delete this ${statusName.toLowerCase()} notification permanently?`;

  const [page, setPage] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(6);
  const [total, setTotal] = useState(0);
  const [notifications, setNotifications] = useState([]);

  const navigate = useNavigate();
  const [geofenceNotificationCards, setGeofenceNotificationCards] = useState<any[]>([]);
  const [deleteModal, setDeleteModal] = useState<{ open: boolean; id?: string }>({ open: false });
  const [messageApi, contextHolder] = message.useMessage();
  const [isPageLoading, setIsPageLoading] = useState<boolean>(true);
  const [showMobilePreview, setShowMobilePreview] = useState<boolean>(false);

const formatDate = (dateStr?: string) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
    return `${month}/${day}/${year}`;
  };

  const handleGeofenceNotificationDelete = async (geofenceNotificationId: string) => {
    
    setDeleteModal({ open: false });
    setIsPageLoading(true);
    try {
      const response = await geofenceNotificationApi.deleteGeofenceNotification(geofenceNotificationId);
      if (response.status === 200) {
        
        messageApi.success(`Notification deleted successfully.`);
        await getGeofenceNotificationByStatusId();
      }
    } catch (err) {
      messageApi.error("Something went wrong");
      console.error("Failed to load data:", err);
    } 
    finally {
      setDeleteModal({ open: false });
      setIsPageLoading(false);
    }
  };

  // useEffect(() => {
  //   const geofenceNotificationCards = async () => {
  //     try {
  //       await getGeofenceNotificationByStatusId();
      
  //   } catch (err) {
  //       console.error("Failed to load data:", err);
  //     } finally {
  //       setIsPageLoading(false);
  //     }
  //   };
  //   geofenceNotificationCards();
  // }, [navigationTitle]);

  useEffect(() => {
    getGeofenceNotificationByStatusId();
  }, [navigationTitle, statusId]);

   useEffect(() => {
    const sliced = notifications.slice((page - 1) * pageSize, page * pageSize);
    setGeofenceNotificationCards(sliced);
  }, [page, pageSize, notifications]);

  // const getGeofenceNotificationByStatusId = async () => {
  //   try {
  //     const geofenceItems = await geofenceNotificationApi.getGeofenceNotificationByStatusId(statusId, page, pageSize);
  //     //setNotifications(geofenceItems || []);    
  //     setGeofenceNotificationCards(geofenceItems);
  //     setTotal(geofenceItems.length);
  //   } catch (error) {
  //     console.error("Error loading items:", error);
  //   }
  // };

  const getGeofenceNotificationByStatusId = async () => {
    setIsPageLoading(true);
    try {

      const res = await geofenceNotificationApi.getGeofenceNotificationByStatusId(statusId);
      const items = Array.isArray(res) ? res : (res.items ?? res.data ?? []);
      setNotifications(items || []);
      setTotal((items && items.length) ? items.length : 0);

      // Compute first page slice immediately using current page/pageSize
      const firstSlice = (items || []).slice((page - 1) * pageSize, page * pageSize);
      setGeofenceNotificationCards(firstSlice);
    } catch (error) {
      console.error("Error loading items:", error);
      setNotifications([]);
      setGeofenceNotificationCards([]);
      setTotal(0);
    } finally {
      setIsPageLoading(false);
    }
  };

  return (
    <div>
      {contextHolder}

      {isPageLoading && <PageLoader />}

      {/* Delete Modal - Draft */}
      <Modal
        title={deleteMessage}
        open={deleteModal.open}
        onOk={() => deleteModal.id && handleGeofenceNotificationDelete(deleteModal.id)}
        onCancel={() => setDeleteModal({ open: false })}
        okText="Yes"
        cancelText="No"
        centered
        okButtonProps={{
            style: styles.okButton,
            type: "default",
        }}
      />

      {/* Header */}
      <div>
        <Title level={3} style={{ color: "#41787C" }}>
          <Button
            type="link"
            icon={
              <ArrowLeftOutlined
                style={{ fontSize: "18px", fontWeight: "bold", color: "#000", marginRight: 10 }}
              />
            }
            onClick={() => navigate(-1)}
            style={{ marginBottom: "10px", padding: 0, color: "#41787C" }}
          />
          {navigationTitle}
        </Title>
      </div>

      {/* Cards Grid */}

      <div>
            <Row gutter={[16, 16]}>
                {
                geofenceNotificationCards.length > 0 ? (
                geofenceNotificationCards.map((card) => {
                const hasImage = card.geofenceAnnouncementImageResponses?.length > 0;
                const imageUrl =
                    hasImage ? card.geofenceAnnouncementImageResponses[0].fileUrl
                    : null;

                return (
                    <Col xs={24} sm={12} md={8}  key={card.id}>
                    <Card
                        hoverable
                        cover={
                        hasImage ? (
                            <img
                              src={imageUrl!}
                              alt={card.campaignName || "No Image"}
                              style={{ height: 150, objectFit: "cover" }}
                            />
                          ) : (
                            <div
                              style={{
                                height: 150,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                background: "#f0f0f0",
                                color: "#999",
                              }}
                            >
                              No Image
                            </div>
                          )
                        }
                    >
                        <div style={{ display: "flex", flexDirection: "column" }}>
                        {/* Name and Delete */}
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <Tooltip title={card.campaignName || ""}>
                            <div style={{ maxWidth: "90%", display: "flex", alignItems: "center", marginBottom: 4 }}>
                                <Title
                                level={5}
                                style={{
                                  margin: 0,
                                  height: 20,
                                  fontSize: 14,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  display: "-webkit-box",
                                  WebkitLineClamp: 2,
                                  WebkitBoxOrient: "vertical",
                                }}
                                >
                                {card.campaignName.length > 40 ? `${card.campaignName.substring(0, 40)}...`
                                    : card.campaignName}
                                </Title>
                            </div>
                            </Tooltip>
                          <div style={{ display: "flex", gap: 4, flexShrink: 0 }}>
                          <Tooltip title="Edit">
                            <Button
                              type="text"
                              icon={<EditOutlined style={{ color: "#3E767A" }} />}
                              disabled={card.status == 1 || card.status === 3}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/CreateGeofenceNotification", {
                                  state: {
                                    operationName: "update",
                                    geofenceNotificationId: card.id,
                                    redirectedFrom : statusName
                                  },
                                })
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="Delete">
                            <Button
                              type="text"
                              icon={<DeleteOutlined style={{ color: "#3E767A" }} />}
                              disabled={card.status == 1 || card.status === 3}
                              onClick={(e) => {
                                e.stopPropagation();
                                setDeleteModal({ open: true, id: card.id });
                              }}
                            />
                          </Tooltip>
                          <Tooltip title="View">
                            <Button
                              type="text"
                              icon={<EyeOutlined style={{ color: "#3E767A" }} />}
                              onClick={(e) => {
                                e.stopPropagation();
                                navigate("/CreateGeofenceNotification", {
                                  state: {
                                    operationName: "view",
                                    geofenceNotificationId: card.id,
                                    redirectedFrom : statusName
                                  },
                                })
                              }}
                            />
                          </Tooltip>
                          </div>
                        </div>
                        {/* <div style={{ height: "4px" }} /> */}

                        {/* Title Row */}
                        <div style={{ marginBottom: 8 }}>
                          <Tooltip title={card.title}>
                            <Title
                              level={5}
                              style={{
                                margin: 0,
                                height: 20,
                                fontSize: 13,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                display: "-webkit-box",
                                WebkitLineClamp: 2,
                                WebkitBoxOrient: "vertical",
                              }}
                            >
                              {card.title}
                            </Title>
                          </Tooltip>
                        </div>
                        
                        <div>
                            <Tooltip>
                            <Title
                              level={5}
                              style={{
                              margin: "8px 0 0",
                              fontSize: "14px",
                              color: "#C19763",
                                }}
                            >
                               {(() => {
                                const statusOfTitle = Number(card.status);
                                const isActiveOrPast =
                                  statusOfTitle === NotificationStatusMapper.getNotificationStatusId('Active') ||
                                  statusOfTitle === NotificationStatusMapper.getNotificationStatusId('Past');
                                const isUpcoming =
                                  statusOfTitle === NotificationStatusMapper.getNotificationStatusId('Upcoming');

                                if (isActiveOrPast && card.endDate) {
                                  return `Campaign End Date: ${formatDate(card.endDate)} ${card.endTime}`;
                                }
                                
                                if(isActiveOrPast && !card.endDate)
                                {
                                  return `Campaign End Date: ${formatDate(card.startDate)} ${addOneMinute(card.startTime)}`;
                                }

                                if (isUpcoming) {
                                  return `Campaign Start Date: ${formatDate(card.startDate)} ${card.startTime}`;
                                }
                                return ''; // fallback if none match
                              })()}
                            </Title>
                            </Tooltip>
                        </div>
                        {/* Last Saved */}
                        <div>
                            <Tooltip>
                            <Title
                              level={5}
                              style={{
                              margin: "8px 0 0",
                              fontSize: "14px",
                              color: "#C19763",
                                }}
                            >
                                Last Saved: {formatDate(card.createdAt)}
                            </Title>
                            </Tooltip>
                        </div>
                        </div>
                    </Card>
                    </Col>
                );
                }
                )) 
            : (
                <div
                  style={{
                    padding: "40px",
                    textAlign: "center",
                    color: "#888",
                    fontSize: "16px",
                    fontStyle: "italic",
                    backgroundColor: "#fafafa",
                    border: "1px dashed #ddd",
                    borderRadius: "8px",
                    marginTop: "20px",
                  }}
                >
                  No notifications found.
                </div>
              )
              }
            </Row>
            </div>
                

      {/* Mobile Preview Button (fixed bottom-right) */}
      {/* <div style={styles.mobilePreviewBtnWrapper}>
        <button onClick={() => setShowMobilePreview(true)} style={{ ...styles.greenButton, width: 170 }}>
          Mobile Preview
        </button>
      </div> */}

      {/* Mobile Preview Drawer */}
      {showMobilePreview && (
        <>
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100vw",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: 1000,
            }}
            onClick={() => setShowMobilePreview(false)}
          />

          <div
            style={{
              position: "fixed",
              top: 0,
              right: 0,
              width: "420px",
              height: "100vh",
              backgroundColor: "rgba(0, 0, 0, 0.4)",
              boxShadow: "-2px 0 8px rgba(0,0,0,0.3)",
              zIndex: 1001,
              padding: "1rem",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div
              style={{
                flexGrow: 1,
                display: "flex",
                justifyContent: "center",
                alignItems: "flex-start",
                paddingTop: "1rem",
              }}
            >
              {/* <SectionMobilePreviewPage /> */}
            </div>
            <button
              onClick={() => setShowMobilePreview(false)}
              style={{ ...styles.whiteButton, width: 150, color: "black" }}
            >
              Close Preview
            </button>
          </div>
        </>
      )}

      {/* Pagination */}
      <div style={{ marginTop: 16, textAlign: "center" }}>
        <Pagination
          current={page}
          pageSize={pageSize}
          total={total}
          onChange={(newPage, newPageSize) => {
            if (newPageSize && newPageSize !== pageSize) {
              setPageSize(newPageSize);
              setPage(1);
            } else {
              setPage(newPage);
            }
          }}
          showSizeChanger
          pageSizeOptions={["3", "6", "9", "15"]}
        />
      </div>
    </div>
  );
};

export default NotificationListGeofencePage;

// Styles
const baseGreen = "#3E767A";
const styles: { [key: string]: React.CSSProperties } = {
  addCardWrapper: {
    height: "100%",
    minHeight: "250px",
    border: "2px dashed #3E767A",
    borderRadius: "12px",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer",
    background: "#fafafa",
  },
  mobilePreviewBtnWrapper: {
    position: "fixed",
    bottom: "20px",
    right: "20px",
    zIndex: 1000,
  },
  greenButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 20px",
    fontSize: "16px",
    borderRadius: "20px",
    border: `2px solid ${baseGreen}`,
    color: "#F1F2F4",
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    backgroundColor: baseGreen,
    width: "140px",
    height: "40px",
    fontFamily: `'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif`,
  },
  whiteButton: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "0px 20px",
    fontSize: "16px",
    borderRadius: "20px",
    border: `2px solid #f1f2f4`,
    color: baseGreen,
    cursor: "pointer",
    transition: "all 0.2s ease-in-out",
    backgroundColor: "#f1f2f4",
    width: "120px",
    height: "37px",
    boxShadow: "0 2px 0 #FAFAFA",
    transform: "translateY(2px)",
    fontFamily: `'Segoe UI', 'Roboto', 'Helvetica Neue', sans-serif`,
  },
  okButton: {
    backgroundColor: "#3E767A",
    borderColor: "#3E767A",
    color: "#fff",
  },
};
